import { useCallback, useState } from 'react';

import FormDialog from '@sayyesschool/frontend/components/form-dialog';
import LoadingIndicator from '@sayyesschool/frontend/components/loading-indicator';
import Page from '@sayyesschool/frontend/components/page';
import { useUser } from '@sayyesschool/frontend/features/user';
import { useVocabularies, VocabulariesGrid, VocabularyForm, VocabularySimpleForm } from '@sayyesschool/frontend/features/vocabularies';
import { PopoverButton } from '@sayyesschool/frontend/ui-components';

export default function VocabulariesPage() {
    const [user] = useUser();
    const [vocabularies, actions] = useVocabularies();

    const [currentVocabulary, setCurrentVocabulary] = useState(null);

    const numberOfVocabularies = vocabularies?.length;

    const handleAddVocabulary = useCallback(data => {
        return actions.createVocabulary({ learnerId: user.id, ...data });
    }, [actions, user.id]);

    const handleUpdateVocabulary = useCallback((vocabularyId, data) => {
        return actions.updateVocabulary(vocabularyId, data)
            .then(() => setCurrentVocabulary(null));
    }, [actions]);

    const handleDeleteVocabulary = useCallback(vocabularyId => {
        return actions.deleteVocabulary(vocabularyId);
    }, [actions]);

    const handleEditVocabulary = useCallback(vocabulary => {
        setCurrentVocabulary(vocabulary);
    }, []);

    const handleCloseFormDialog = useCallback(() => {
        setCurrentVocabulary(null);
    }, []);

    if (!vocabularies) return <LoadingIndicator fullscreen />;

    return (
        <Page
            className="VocabulariesPage"
            layout="narrow"
        >
            <Page.Header
                title="Словари"
                actions={[
                    <PopoverButton
                        key="new-vocabulary"
                        content="Новый словарь"
                    >
                        <VocabularySimpleForm
                            numberOfVocabularies={numberOfVocabularies}
                            onAddVocabulary={handleAddVocabulary}
                        />
                    </PopoverButton>
                ]}
            />

            <Page.Content>
                <VocabulariesGrid
                    vocabularies={vocabularies}
                    onEditVocabulary={handleEditVocabulary}
                    onDeleteVocabulary={handleDeleteVocabulary}
                />
            </Page.Content>

            {currentVocabulary && (
                <FormDialog
                    title="Редактирование"
                    open={!!currentVocabulary}
                    onClose={handleCloseFormDialog}
                >
                    <VocabularyForm
                        id="vocabulary-edit-form"
                        vocabulary={currentVocabulary}
                        submit={handleUpdateVocabulary}
                    />
                </FormDialog>
            )}
        </Page>
    );
}